import { PALETTES } from 'design-assets/constants/palettes.js';
import { SIZES } from 'design-assets/constants/sizes.js';

export const VALID_SIZES = [
    SIZES.SMALL,
    SIZES.LARGE,
];

export const VALID_PALETTES = [
    PALETTES.ACCENT,
    PALETTES.MENTION,
    PALETTES.WARNING,
    PALETTES.DANGER,
    PALETTES.DARK_PRIMARY,
    PALETTES.LIGHT_PRIMARY,
];
